<template>
	<InputBase v-bind="{ ...$attrs, ...$props }" v-on="listeners" />
</template>

<script>
import InputBase from './InputBase.vue';
export default {
	components: {
		InputBase,
	},
	model: {
		prop: 'value',
		event: 'update',
	},
	props: {
		value: String,
	},
	computed: {
		listeners() {
			return {
				...this.$listeners,
			};
		},
	},

	methods: {
		focus() {
			this.$el.querySelectorAll('input,select,textarea')[0]?.focus();
		},
	},
};
</script>
